<template>
  <div class="parent">
  <template v-if="checkData(objectData)">
    <template v-for="item in objectData">
      <el-menu-item v-if="!item?.children?.length" :key="item.categoryIndex" :index="item.categoryIndex">
        <i>{{ item.categoryTitle}}</i>
      </el-menu-item>
      <el-submenu class="child-menu" v-else :key="item.categoryIndex" :index="item.categoryIndex">
        <template slot="title">
          <i>{{ item.categoryTitle}}</i>
        </template>
        <SubMenuTree :objectData="item.children"></SubMenuTree>
      </el-submenu>
    </template>
  </template>
  <template v-else>
    <el-submenu :index="objectData.categoryIndex" >
      <template slot="title">{{objectData.categoryTitle}}</template>
      <template v-for="item in objectData.children">
        <el-menu-item v-if="!item?.children?.length" :key="item.categoryIndex" :index="item.categoryIndex">
          <i>{{ item.categoryTitle }}</i>
        </el-menu-item>
        <el-submenu class="child-menu" v-else :key="item.categoryIndex" :index="item.categoryIndex">
          <template slot="title">
            <i>{{ item.categoryTitle }}</i>
          </template>
          <SubMenuTree :objectData="item.children"></SubMenuTree>
        </el-submenu>
      </template>
    </el-submenu>
  </template>
  </div>
</template>
<script>
export default {
  name: 'SubMenuTree',  // 很重要，调用自身需要用到
  props: ['objectData'],
  data() {
    return {
    }
  },
  mounted() {
    // setTimeout(()=>{
    //   debugger
    // },6000)

  },
  methods: {
    checkData(item){
     return  Object.prototype.toString.call(item) === '[object Array]'
    }

  }
}
</script>
<style lang="scss" scoped>
.el-submenu-back {
  margin-right: 0 !important;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-left: 2px;
}
.nav {
  width: 100%;
  color: #fff;
  height: 120px;
  position: relative;
  padding: 40px 36px 0 0;
  min-width: 1440Px;
  .menu {
    position: absolute;
    display: flex;
    left: 480px;
    top: 46px;
    .el-menu:nth-child(2) {
      margin-left: 80px;
    }
  }
  .logo {
    width: 64px;
    height: 64px;
    position: absolute;
    top: 28px;
    left: 36px;
    img {
      width: 64px;
      height: 64px;
    }
  }
  .title {
    position: absolute;
    top: 28px;
    left: 36px;
    font-size: 24px;
    cursor: pointer;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 1;
    // display: flex;
    // flex-wrap: wrap;
  }
  .title2 {
    margin-left: 80px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 28px;
  }
  .title2-span {
    font-size: 0;
  }
  .title2:hover {
    color: #f53f3f;
  }
  .btn {
    float: right;
    padding: 12px 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    border: 1px solid #fff;
    border-radius: 8px;
    background-color: transparent;
    color: #fff;
  }
}
.el-menu-demo {
  border-bottom: solid 0px;
}
.child-menu > div.el-menu--horizontal {
  //left: 210px !important;
}
.el-menu--popup-right-start {
  margin: 0;
}
.el-submenu {
  margin-right: 16px;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
  color: #f53f3f;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover .el-icon-arrow-down {
  color: #f53f3f;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 20px;
  color: #fff;
  line-height: 28px;
  padding: 0;
  height: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  border-bottom: 0 solid transparent;
  font-weight: 600;
}
.el-dropdown {
  position: absolute;
  top: 46px;
  left: 480px;
  color: #fff;
  font-size: 20px;
}
.icon-search {
  position: absolute;
  right: 156px;
  width: 40px;
  height: 40px;
}
::v-deep ul.el-menu .el-menu--popup {
  //background-color: red !important;
  border-radius: 8px;
  min-width: 0px !important;
}
.el-menu-item {
  background-color: transparent !important;
  // opacity: 0.9;
  padding: 0px 8px;
  height: 49px !important;
}
.el-menu-item i {
  display: block;
  // width: 168px;
  // padding: 12px 0;
  color: #1d2129;
  text-align: center;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  opacity: 1 !important;
  line-height: 49px;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  line-height: 49px;
}
.el-menu-item:hover i {
  display: block;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.el-menu-item:active i {
  color: #f53f3f;
}
.child-menu {
  margin-right: 0;
  height: 49px;
}
.child-menu > ::v-deep div.el-submenu__title {
  height: 49px;
  line-height: 49px;
}
.el-submenu__title i {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
}
.child-menu > ::v-deep div.el-submenu__title:hover {
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
::v-deep .el-submenu__title {
  background-color: #fff !important;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 25px;
}
v-deep .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #1d2129 !important;
}
::v-deep .el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
}

::v-deep div.el-menu,
div.el-menu--popup,
div.el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
  border-radius: 8px;
}
// menu 样式大全
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: rgba(255, 255, 255, 0.6);
  float: none;
  color: #1d2129 !important;
  z-index: 100;
  font-weight: 500;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  // line-height: 25px;
  text-align: center;
}
::v-deep ul.el-menu .el-menu--popup {
  //background-color: red !important;
  border-radius: 8px;
  min-width: 0px !important;
}
.el-menu-item {
  // background-color: #ffffffd5 !important;
  // opacity: 0.9;
  padding: 0px 8px;
  height: 49px;
}
.el-menu-item i {
  display: block;
  // width: 168px;
  // padding: 12px 0;
  color: #1d2129;
  text-align: center;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  opacity: 1 !important;
  line-height: 49px;
}
.el-menu-item:hover i {
  display: block;
  // width: 168px;
  // height: 49px;
  background: #fff;
  // opacity: 1 !important;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // line-height: 49px;
}
::v-deep .el-submenu__title {
  background-color: transparent !important;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 25px;
}
v-deep .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #1d2129 !important;
}
::v-deep .el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
}
::v-deep div.el-menu,
div.el-menu--popup,
div.el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
  border-radius: 8px;
}
// menu 样式大全
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: rgba(255, 255, 255, 0.6);
  float: none;
  color: #1d2129 !important;
  z-index: 100;
  font-weight: 500;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 25px;
  text-align: center;
}
.el-button.is-plain:hover {
  background-color: #fff !important;
  color: #f53f3f !important;
}
.nav .btn {
  span {
    width: 32px;
    height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24px;
  }
}

li.el-menu-item.jumpHome {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
  border-bottom: 0;
  margin-right: 34px;
}
.el-menu-item[data-v-c6e7507a]:hover,
.el-menu-item[data-v-c6e7507a]:focus {
  color: #f53f3f !important;
}
.svgIcon {
  width: 40px;
  height: 40px;
}

.title_English {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 1;
  display: inline-block;
}
.title_Chinese {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1;
  display: block;
}
.svg-icon {
  width: 32px;
  height: 32px;
  color: #fff;
}
.title_logo {
  width: 296px;
  height: 64px;
}
</style>
